exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".alp-button{background:#fff;border:0;border-radius:8px;color:#23b9d0;display:inline-block;font-family:Source Sans Pro,sans-serif;font-size:24px;font-weight:600;text-decoration:none;padding:15px 20px}.alp-button--blued{background-color:#23b9d0;color:#fff}.alp-button--shadowed{box-shadow:0 2px 4px 0 rgba(0,0,0,.5)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1da44376","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/Button.vue
// module id = 59
// module chunks = 0